module.exports = __webpack_public_path__ + "img/research_5.792e8e04.png";